import type { ChatMessage } from '../stores/agent'

// A turn another agent delivered (direct message or channel post) carries the
// sender's self-signed name; owner-typed turns never do (#1837).
export function isInterAgentTurn(m: ChatMessage): boolean {
  return m.role === 'you' && !!m.sender_name
}

// `ui_user` is the server-set marker for a verified owner login; everything
// else came in over MCP and is only as trustworthy as the agent's signature.
export function isOwnerSource(source: string | null | undefined): boolean {
  return source === 'ui_user'
}

export function sourceLabel(source: string | null | undefined): string {
  return isOwnerSource(source) ? 'verified login' : 'MCP'
}
